import PropTypes from "prop-types"
import React, { useEffect } from "react"
import styled from "styled-components"

import BottomSheet from "../../../../../_shared/components/BottomSheet"
import AppInput from "../../../../../_shared/components/FormItems/AppInput"
import AppSwitch from "../../../../../_shared/components/FormItems/AppSwitch"
import AppHeading from "../../../../../_shared/components/Typography/Heading"
import useForm from "../../../../../_shared/hooks/useForm"

// ----------------------------------------------------------------------------

const defaultValues = {
    minAge: 35,
    maxAge: 49,
    slotLockDurationMinutes: 120,
    allowMales: false,
    allowFemales: false,
}

function _DocumentsBottomSheet(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { document, onConfirm, onCancel, open } = props

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    const [formValues, setFormValue, setFormValues, clearFormValues] =
        useForm(defaultValues)

    // -------------------------------------
    // Effects
    // -------------------------------------

    useEffect(() => {
        document && setFormValues({ ...defaultValues, ...document })
        //eslint-disable-next-line
    }, [document])

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function handleConfirm() {
        onConfirm && onConfirm(formValues)
    }

    function handleSubmit(e) {
        e.preventDefault()
        handleConfirm()
    }

    function handleClose() {
        clearFormValues()
        onCancel && onCancel()
    }

    function handleValueChange(field) {
        return (e) => {
            //   console.log(field, e);
            if (typeof e === "string") {
                setFormValues({ ...formValues, [field]: e })
            } else if (Array.isArray(e)) {
                setFormValues({ ...formValues, [field]: [...e] })
            } else {
                setFormValues({ ...formValues, [field]: e.target.value })
            }
        }
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <BottomSheet
            open={open}
            className={props.className}
            onCancel={handleClose}
            onConfirm={handleConfirm}
            title={formValues?.id ? "Modifica tipologia" : "Crea tipologia"}
            snapPoint={90}
        >
            <form className="form" onSubmit={handleSubmit}>
                <AppHeading className="heading" boldness="medium">
                    Nome
                </AppHeading>
                <AppInput
                    className="field"
                    value={formValues?.name}
                    onChange={handleValueChange("name")}
                />
                <AppHeading className="heading" boldness="medium">
                    Età minima di partecipazione
                </AppHeading>
                <AppInput
                    className="field"
                    placeholder="35"
                    type="number"
                    value={formValues?.minAge}
                    onChange={handleValueChange("minAge")}
                />
                <AppHeading className="heading" boldness="medium">
                    Età massima di partecipazione
                </AppHeading>
                <AppInput
                    className="field"
                    placeholder="49"
                    type="number"
                    value={formValues?.maxAge}
                    onChange={handleValueChange("maxAge")}
                />
                <AppHeading className="heading" boldness="medium">
                    Durata visita (minuti)
                </AppHeading>
                <AppInput
                    className="field"
                    type="number"
                    value={formValues?.slotDuration}
                    onChange={handleValueChange("slotDuration")}
                />
                <AppSwitch
                    className="switch"
                    label="Accessibile a femmine"
                    value={formValues?.allowFemales}
                    onChange={(checked) =>
                        setFormValue("allowFemales", checked)
                    }
                />
                <AppSwitch
                    className="switch"
                    label="Accessibile a maschi"
                    value={formValues?.allowMales}
                    onChange={(checked) => setFormValue("allowMales", checked)}
                />
                <AppSwitch
                    className="switch"
                    label="Richiede la compilazione del modulo dell'operatore sanitario"
                    value={formValues?.requiresProviderForm}
                    onChange={(checked) =>
                        setFormValue("requiresProviderForm", checked)
                    }
                />

                {formValues?.requiresProviderForm && (
                    <>
                        <AppHeading className="heading" boldness="medium">
                            Durata di blocco dello slot (minuti)
                        </AppHeading>
                        <AppInput
                            className="field"
                            type="number"
                            value={formValues?.slotLockDurationMinutes}
                            onChange={handleValueChange(
                                "slotLockDurationMinutes"
                            )}
                        />
                    </>
                )}
            </form>
        </BottomSheet>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_DocumentsBottomSheet.propTypes = {
    className: PropTypes.string.isRequired,
    document: PropTypes.any,
    open: PropTypes.bool,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
}

_DocumentsBottomSheet.defaultProps = {}

// ----------------------------------------------------------------------------

const EventTypesBottomSheet = styled(_DocumentsBottomSheet)`
    & {
        .heading {
            margin-top: 30px;
        }
        .field {
            width: 500px;
        }
        .switch {
            margin-top: 30px;
        }
    }
`
// ----------------------------------------------------------------------------

export default EventTypesBottomSheet
